import { render, staticRenderFns } from "./guideProduct.vue?vue&type=template&id=521f3a48&scoped=true"
import script from "./guideProduct.vue?vue&type=script&lang=js"
export * from "./guideProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f3a48",
  null
  
)

export default component.exports